import { render, staticRenderFns } from "./Dataset_CNV_grid.vue?vue&type=template&id=3ea0dc86&scoped=true&"
import script from "./Dataset_CNV_grid.vue?vue&type=script&lang=js&"
export * from "./Dataset_CNV_grid.vue?vue&type=script&lang=js&"
import style0 from "./Dataset_CNV_grid.vue?vue&type=style&index=0&id=3ea0dc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0dc86",
  null
  
)

export default component.exports